var _defs, _rect, _g, _g2, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginpassLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 160",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#dfe5eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e2e8f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logoGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1e40af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "red"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 390,
    height: 140,
    rx: 20,
    fill: "url(#bgGradient)",
    stroke: "#cbd5e1",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,15 C0,5 20,0 40,0 C60,0 80,5 80,15 C80,60 50,90 40,90 C30,90 0,60 0,15 Z",
    fill: "#ffffff",
    stroke: "url(#logoGradient)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,25 C40,30 50,35 40,45 C30,55 40,60 50,65",
    stroke: "#3b82f6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,25 C40,30 30,35 40,45 C50,55 40,60 30,65",
    stroke: "#1e40af",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 25,
    r: 3,
    fill: "#1e40af"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 25,
    r: 3,
    fill: "#1e40af"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 45,
    r: 3,
    fill: "#1e40af"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 65,
    r: 3,
    fill: "#1e40af"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 65,
    r: 3,
    fill: "#1e40af"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130, 55)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 32,
    fill: "#1e40af"
  }, "PASS"), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 45,
    x2: 250,
    y2: 45,
    stroke: "#94a3b8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 65,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#475569"
  }, "\n      Polio Assessment Sequence Screening\n    "), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 85,
    fontFamily: "Arial, sans-serif",
    fontStyle: "italic",
    fontSize: 12,
    fill: "#64748b"
  }, "\n      Centers for Disease Control and Prevention\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 30,
    r: 5,
    fill: "red",
    opacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 30,
    r: 3,
    fill: "red",
    opacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 30,
    r: 3,
    fill: "red",
    opacity: 0.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 20,
    r: 3,
    fill: "red",
    opacity: 0.7
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 40,
    r: 3,
    fill: "red",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginpassLogo);
export default __webpack_public_path__ + "static/media/loginpassLogo.4226f19459b9ee97a5b8674df37152b2.svg";
export { ForwardRef as ReactComponent };